import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'underscore';
import { message } from 'antd';
import Api from '../../../../api/Api';
import { QUERY_KEYS } from '../../../../queries/queryKeys';

export const useDatasetPrice = (datasetId: string, startDate?: string, endDate?: string) => {
  const [price, setPrice] = useState(999);

  const priceQuery = useQuery({
    queryKey: [QUERY_KEYS.dataset.price, datasetId, startDate, endDate],
    queryFn: async () => {
      if (isEmpty(datasetId) && !startDate && !endDate) {
        return null;
      }

      const response = await Api.price.GetDatasetPriceByPeriod(
        datasetId,
        startDate!,
        endDate!
      );

      if (response && response.Result !== null && response.Result.Price !== null) {
        return response.Result.Price;
      }

      if (response.Error !== null) {
        const errorMessage = response.Error.ErrorMessage
          ? response.Error.ErrorMessage
          : 'Failed to calculate the price';
        throw new Error(errorMessage);
      }

      return 999;
    },
    enabled: !!datasetId && !!startDate && !!endDate,
    retry: false
  });

  useEffect(() => {
    if (priceQuery.data !== undefined) {
      setPrice(priceQuery.data);
    }
  }, [priceQuery.data]);

  useEffect(() => {
    if (priceQuery.error) {
      message.error(priceQuery.error.message || 'Failed to calculate the price');
      setPrice(999);
    }
  }, [priceQuery.error]);

  return {
    price,
    isLoading: priceQuery.isLoading,
    isError: priceQuery.isError,
    error: priceQuery.error
  };
};
